import React, { useEffect, useState } from 'react';
import styles from './partner-info.module.scss';
import { PUBLIC_PATH } from '../../../../../shared/config/routes-config';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../../../shared/components/core-ui/button/button.component';
import { trackEvent } from '../../../../../shared/services/utils/tracking/tracking.service';
import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
import { ConfirmModal } from '../../components/confirm-modal/confirm-modal.component';
import EdiText from 'react-editext';

export interface PartnerInfoProps {
  data: {
    partnerName: string;
    partnerId: string;
    partnerEmail: string;
    partnerPhone: string;
    propertyId: string;
    partnerShare: number;
  };
  eventHandlers: {
    addPartner: () => void;
    updatePartnerShare: (share: number) => void;
    deletePartner: () => void;
  };
}
export const PartnerInfo: React.FC<PartnerInfoProps> = ({ data, eventHandlers }) => {
  const isMobileView = useWindowResizer();
  const [disabledActions, setDisabledActions] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [confirmModalMessage, setConfirmModalMessage] = useState<string>('');

  return (
    <div className={styles['partner-info-container']}>
      {data.partnerId ? (
        <>
          <div className={styles['partner-info-container-title']}>Partner Info</div>
          <div className={styles['partner-info-container-content']}>
            {/* <div className={styles['partner-info-container-content-info']}>
              <label>id :</label>
              <p> {data.partnerId}</p>
            </div> */}
            <div className={styles['partner-info-container-content-info']}>
              <label>Name :</label> <p>{data.partnerName}</p>
            </div>
            <div className={styles['partner-info-container-content-info']}>
              <label>Email :</label> <p>{data.partnerEmail}</p>
            </div>
            <div className={styles['partner-info-container-content-info']}>
              <label>Phone :</label> <p>{data.partnerPhone}</p>
            </div>
            <div className={styles['partner-info-container-content-info']} />
            <div className={styles['partner-info-container-content-info']}>
              <label>Partner Share :</label>{' '}
              <EdiText
                className={styles['partner-info-container-content__edit-text']}
                type="text"
                onEditingStart={(value) => {
                  setDisabledActions(true);
                }}
                onCancel={() => {
                  setDisabledActions(false);
                }}
                value={data.partnerShare + '%'}
                onSave={(val: string) => {
                  setDisabledActions(false);
                  eventHandlers.updatePartnerShare(Number(val.replace('%', '')));
                }}
              />
            </div>
          </div>

          <div className={styles['partner-info-container-actions']}>
            <Button
              onClick={() => {
                // if (data.payouts && data.payouts.length > 0) {
                //   setShowConfirmModal(true);
                //   setConfirmModalMessage(
                //     'Do you want to update payouts assigned to this Homeowner also?'
                //   );
                // } else {
                eventHandlers.addPartner();
                // }
              }}
              tracking={{
                action: 'cancel',
                category: '',
                label: ''
              }}
              size={isMobileView ? ButtonSize.full : ButtonSize.medium}
              disabled={data.propertyId === '' || disabledActions}
            >
              {' '}
              Update Partner
            </Button>

            <Button
              onClick={() => {
                setShowDeleteModal(true);
              }}
              tracking={{
                action: 'open',
                category: 'blocked-date',
                label: 'add-blocked-date-modal'
              }}
              type={ButtonType.primaryInverted}
              size={ButtonSize.medium}
              disabled={disabledActions}
            >
              Delete Partner
            </Button>
          </div>
        </>
      ) : (
        <div>
          <img
            src={`${PUBLIC_PATH}/assets/jpeg/partner.jpeg`}
            alt="assign Partner"
            className={styles['partner-info-container-content-image']}
          />

          <Button
            onClick={() => {
              eventHandlers.addPartner();
              trackEvent('add', {
                category: '',
                label: ''
              });
            }}
            tracking={{
              action: 'cancel',
              category: '',
              label: ''
            }}
            size={isMobileView ? ButtonSize.full : ButtonSize.medium}
            disabled={data.propertyId === '' || disabledActions}
          >
            {' '}
            Assign Partner
          </Button>
          {data.propertyId === '' && (
            <label className={styles['partner-info-container-content--hint']}>
              you can't assign a Partner to a unit that doesn't have property
            </label>
          )}
        </div>
      )}

      {/* <ConfirmModal
        config={{ showModal: showConfirmModal, message: confirmModalMessage }}
        eventHandlers={{
          denyAction: () => {
            setShowConfirmModal(false);
            eventHandlers.addPartner(false);
          },
          confirmAction: () => {
            setShowConfirmModal(false);
            eventHandlers.addPartner(true);
            trackEvent('add', {
              category: '',
              label: ''
            });
          }
        }}
      /> */}

      <ConfirmModal
        config={{
          showModal: showDeleteModal,
          message: 'Are you sure you want to delete this Partner?'
        }}
        eventHandlers={{
          denyAction: () => {
            setShowDeleteModal(false);
          },
          confirmAction: () => {
            setShowDeleteModal(false);
            eventHandlers.deletePartner();
          }
        }}
      />
    </div>
  );
};
